<template>
  <div>
    <base-rounded-button
      size="x-small"
      @click="openMultilanguageDialog"
      :tooltip="$i18n.t('default.editMultilanguage')"
      icon="mdi-translate"
      color="rgba(235, 235, 235, 0.5)"
      iconColor="#202124"
    />
    <main-large-dialog
      v-if="isDialogLoaded"
      :is-visible.sync="isDialogVisible"
      :title="$i18n.t('sidebar.smartMatchMultilanguage.title')"
      dialog-width="80%"
      min-body-height="70vh"
      max-height="95vh"
      no-paddings-y
      no-paddings-x
      @agree="save"
      :is-valid="isFormValid"
      :loading="isLoading"
      agree-text="dialog.agreeSave"
    >
      <template #body>
        <v-row v-if="isFetched" no-gutters class="pa-6">
          <v-col>
            <v-row no-gutters class="py-2 row-borders border-top align-center">
              <v-col v-for="(column, index) in tableHeaders" :key="index" class="px-6 py-3 text--secondary">
                {{ column.text }}
              </v-col>
            </v-row>
            <v-form v-model="isFormValid">
              <template v-for="(item, index) in items">
                <v-row
                  v-if="Object.keys(item.inputs).length > 0"
                  no-gutters
                  class="row-borders align-baseline"
                  :key="index"
                >
                  <v-col v-for="(column, index) in tableHeaders" :key="index" class="px-6">
                    <span v-if="column.isNotData">
                      {{ item[column.value] }}
                    </span>
                    <div v-else>
                      <data-input
                        wrap-text
                        class="pt-6"
                        v-if="item.inputs[column.key]"
                        v-bind="item.inputs[column.key]"
                        v-model="computedValues[item.inputs[column.key].attribute]"
                      />
                    </div>
                  </v-col>
                </v-row>
              </template>
            </v-form>
          </v-col>
        </v-row>
        <v-row no-gutters v-else>
          <v-col>
            <main-loader class="pt-10" />
          </v-col>
        </v-row>
      </template>
    </main-large-dialog>
  </div>
</template>
<script>
import DataInput from '@/components/DataInput';
import { call, get } from 'vuex-pathify';
export default {
  name: 'FeatureCardMultilanguage',
  components: {
    MainLargeDialog: () => import('@/components/MainLargeDialog'),
    MainLoader: () => import('@/components/MainLoader'),
    DataInput,
  },
  props: {
    dataSource: {
      type: String,
      required: true,
    },
    smartMatchProfile: {
      type: Number,
      default: null,
    },
    formSchema: {
      type: Array,
      default: () => [],
    },
    values: {
      type: Object,
      default: () => ({}),
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    isDialogLoaded: false,
    isDialogVisible: false,
    isFetched: false,
    profileMappings: null,
    isFormValid: false,
  }),
  computed: {
    profiles: get('smartMatch/profiles'),
    attributesMetadata: get('layers/metadata@:dataSource.attributes_schema.attributes'),
    computedValues: {
      get() {
        return this.values;
      },
      set(nV) {
        this.$emit('update:values', nV);
      },
    },
    tableHeaders() {
      return [
        {
          text: this.$i18n.t('sidebar.smartMatchMultilanguage.helpName'),
          align: 'center',
          value: 'helpName',
          isNotData: true,
        },
        ...this.profiles[this.smartMatchProfile]?.columns.map(column => {
          return {
            key: column.id,
            text: column.name,
            value: column.key,
            align: 'center',
          };
        }),
      ];
    },
    items() {
      const attributes = this.$_flattenStructure(this.formSchema, 'elements');
      return this.profileMappings.map(mapping => {
        const mappingData = {
          helpName: mapping.name,
          inputs: {},
        };
        mapping.attributes.forEach(attr => {
          const attributeMetadata = attributes ? attributes.find(att => att.attribute === attr.attribute) : {};
          mappingData.inputs[attr.column_id] = attributeMetadata;
        });
        return mappingData;
      });
    },
  },
  methods: {
    getProfileMappings: call('smartMatch/getProfileMappings'),
    getProfiles: call('smartMatch/getProfiles'),
    openMultilanguageDialog() {
      this.isDialogLoaded = true;
      this.isDialogVisible = true;
    },
    save() {
      this.$root.$emit('featureEditing');
    },
    async init() {
      this.isFetched = false;
      await this.getProfiles();
      this.profileMappings = await this.getProfileMappings(this.smartMatchProfile);
      this.isFetched = true;
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style lang="scss" scoped>
.border-top {
  @include border(top, 1px);
}
.row-borders {
  @include border(bottom, 1px);
  @include border(left, 1px);
  @include border(right, 1px);
}
</style>
